import { Component, inject, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatTableModule } from '@angular/material/table';
import { Option } from '../../misc/nested-options';
import { MatTooltip } from "@angular/material/tooltip";
import { MatIconModule } from '@angular/material/icon';

export interface ImportContactConfirmData {
  newContact: boolean,
  newOrganisation: boolean,
  originalData: {
    firstName: string,
    lastName: string,
    email: string,
    position: string | null,
    organisation: string | null,
    topicsOfInterest: Option[],
    stakeholderGroups: Option[],
  },
  importData: {
    firstName: string,
    lastName: string,
    email: string,
    position: string | null,
    organisation: string | null,
    topicsOfInterest: Option[],
    stakeholderGroups: Option[],
  },
  firstNameModified: boolean,
  lastNameModified: boolean,
  emailModified: boolean,
  positionModified: boolean,
  organisationModified: boolean,
  topicsOfInterestModified: boolean,
  stakeholderGroupsModified: boolean
}

@Component({
  selector: 'app-import-contact-confirm',
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatTableModule,
    MatChipsModule,
    MatTooltip,
    MatIconModule
  ],
  templateUrl: './import-contact-confirm.component.html',
  styleUrl: './import-contact-confirm.component.scss',
})
export class ImportContactConfirmComponent {
  data = inject<ImportContactConfirmData>(MAT_DIALOG_DATA);

  rows = [
    {
      label: 'First name',
      originalValue: this.data.originalData.firstName,
      newValue: this.data.importData.firstName,
      added: (this.data.newContact ? 'contact' : undefined),
      modified: this.data.firstNameModified
    },
    {
      label: 'Last name',
      originalValue: this.data.originalData.lastName,
      newValue: this.data.importData.lastName,
      added: (this.data.newContact ? 'contact' : undefined),
      modified: this.data.lastNameModified
    },
    {
      label: 'Email',
      originalValue: this.data.originalData.email,
      newValue: this.data.importData.email,
      added: (this.data.newContact ? 'contact' : undefined),
      modified: this.data.emailModified
    },
    {
      label: 'Position',
      originalValue: this.data.originalData.position,
      newValue: this.data.importData.position,
      added: false,
      modified: this.data.positionModified
    },
    {
      label: 'Organisation',
      originalValue: this.data.originalData.organisation,
      newValue: this.data.importData.organisation,
      added: (this.data.newOrganisation ? 'organisation' : undefined),
      modified: this.data.organisationModified
    },
    {
      label: 'Topics of interest',
      originalValue: this.data.originalData.topicsOfInterest.map(v => v.name).sort((a, b) => a.localeCompare(b)),
      newValue: this.data.importData.topicsOfInterest.map(v => v.name).sort((a, b) => a.localeCompare(b)),
      added: false,
      modified: this.data.topicsOfInterestModified
    },
    {
      label: 'Stakeholder Groups',
      originalValue: this.data.originalData.stakeholderGroups.map(v => v.name).sort((a, b) => a.localeCompare(b)),
      newValue: this.data.importData.stakeholderGroups.map(v => v.name).sort((a, b) => a.localeCompare(b)),
      added: false,
      modified: this.data.stakeholderGroupsModified
    },
  ];

  isArray(value: unknown): value is string[] {
    return Array.isArray(value);
  }
}
